import slice from "./catchmentSlice";

export default slice.reducer;
